import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { AppChooserDialogActions } from './app-chooser-dialog.actions';

@Injectable()
export class AppChooserDialogEffects {

  constructor(
    private readonly actions$: Actions,
  ) {}

  selectApp$ = createEffect(
    () => this.actions$.pipe(
      ofType(AppChooserDialogActions.selectApp),
      map(() => AppChooserDialogActions.close()),
    ),
  );
}
